"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var UserSearchSelector = (function () {
    function UserSearchSelector(allAccountUsers, teamMembers, onSelect, onInvited, getTeam, getDomId, createUi, getFullName, userIconFactory, make, InviteUserPopup) {
        var _this = this;
        this.onSelect = onSelect;
        this.onInvited = onInvited;
        var filterUsers = function (usersToSearch, searchTerm) {
            console.log(usersToSearch);
            if (searchTerm) {
                return lodash_1.default.filter(usersToSearch, function (userInfo) {
                    if (!searchTerm) {
                        return true;
                    }
                    if (getFullName(userInfo).match(new RegExp("\\b".concat(searchTerm), "i"))) {
                        return true;
                    }
                    return false;
                });
            }
            else {
                return [];
            }
        };
        var showInviteWidget = function (anEmail) {
            _this.ui.inviteView = make(InviteUserPopup, {
                options: {
                    inputEmail: anEmail,
                },
                hasSeatsRemaining: function () {
                    return true;
                },
                getTeam: function () {
                    return getTeam();
                },
                getDomId: getDomId,
                onInvited: function () {
                    return _this.ui.inviteUserToTeam(anEmail);
                },
            }).ui;
            _this.ui.inviteVisible = true;
        };
        var hideInviteWidget = function () {
            _this.ui.inviteView = null;
            _this.ui.inviteVisible = false;
        };
        var showAddUserWidget = function (matchingUsers) {
            _this.setMatchingUsers(matchingUsers);
            _this.showSearchResults();
        };
        var hideAddUserWidget = function () {
            _this.hideSearchResults();
        };
        this._ui = createUi(require("./UserSearchSelector.html"), {
            getMatchingUsers: function () {
                return _this.getMatchingUsers();
            },
            getDomId: getDomId,
            searchResultsVisible: false,
            inviteVisible: false,
            inviteView: undefined,
            addUserToTeam: function (theUser) {
                _this.onSelect(theUser);
                _this.ui.searchResultsVisible = false;
                _this.ui.searchInviteInput = "";
            },
            inviteUserToTeam: function (userEmail) {
                _this.onInvited(userEmail);
                hideInviteWidget();
                _this.ui.searchInviteInput = "";
            },
            searchInviteInput: "",
            updateSearchInvite: function () {
                var searchUserList = lodash_1.default.differenceBy(allAccountUsers, teamMembers, "_id");
                var matchedUsers = filterUsers(searchUserList, _this.ui.searchInviteInput);
                if (matchedUsers.length > 0) {
                    if (_this.ui.inviteVisible && _this.ui.inviteView) {
                        hideInviteWidget();
                    }
                    showAddUserWidget(matchedUsers);
                }
                else {
                    hideAddUserWidget();
                    showInviteWidget(_this.ui.searchInviteInput);
                }
                if (_this.ui.searchInviteInput == "") {
                    hideAddUserWidget();
                    hideInviteWidget();
                }
            },
        });
        this.formatUsers = function (users) {
            return lodash_1.default.map(users, function (uu) {
                var tempUser = lodash_1.default.cloneDeep(uu);
                tempUser.fullName = getFullName(tempUser);
                tempUser.icon = userIconFactory.create(tempUser, {
                    textColor: "#242C39",
                    backgroundColor: "#B6B9BD",
                });
                return tempUser;
            });
        };
        this._matchingUsers = [];
    }
    UserSearchSelector.prototype.getMatchingUsers = function () {
        return this._matchingUsers;
    };
    UserSearchSelector.prototype.setMatchingUsers = function (matchingUsers) {
        return (this._matchingUsers = this.formatUsers(matchingUsers));
    };
    UserSearchSelector.prototype.showSearchResults = function () {
        this.ui.searchResultsVisible = true;
    };
    UserSearchSelector.prototype.hideSearchResults = function () {
        this.ui.searchResultsVisible = false;
    };
    Object.defineProperty(UserSearchSelector.prototype, "ui", {
        get: function () {
            return this._ui;
        },
        enumerable: false,
        configurable: true
    });
    return UserSearchSelector;
}());
exports.default = UserSearchSelector;
